var map = {
	"./Case_Havelaar_1080x1920_Mobile_BananaDay_01.mp4": 94682,
	"./Case_Havelaar_1080x1920_Mobile_BananaDay_02.mp4": 64765,
	"./Case_Havelaar_1080x1920_Mobile_BananaDay_03.mp4": 70664,
	"./Case_Havelaar_1080x1920_Mobile_BananaDay_04.mp4": 87043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48917;